import React from 'react';
import PropTypes from 'prop-types';
import './card.scss';

const Card = ({type = null, className = null, children}) => {
    return (
        <div className={`${className ? className : ''} card ${type ? `card-${type}` : ''}`}>
            {children}
        </div>
    );
};

Card.propTypes = {
    type: PropTypes.string
};

export { Card };